import {
    createRouter,
    createWebHistory,
    createWebHashHistory
} from 'vue-router'
import Loading from '@/methods/loading'
import {
    bgImages
} from '@/methods/methods'

const routes = [{
        path: "/",
        redirect: "/login"
    },
    {
        path: '/login',
        component: () => import('../views/login.vue')
    },
    {
        path: '/travel',
        component: () => import('../views/travel.vue')
    },
    {
        path: '/startPoint',
        component: () => import('../views/startpoint.vue')
    },
    {
        path: '/chain',
        component: () => import('../views/chain.vue')
    },
    {
        path: '/water',
        component: () => import('../views/water.vue')
    },
    {
        path: '/index',
        component: () => import('../views/index.vue')
    },{
        path: '/supply',
        component: () => import('../views/supply.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, form, next) => {
    if (to.path != '/login') {
        Loading.open()
        setTimeout(() => {
            Loading.close()
        }, 2000)
    }
    let app = document.querySelector('#app')
    app.style.background = `url(${bgImages()[to.path]}) no-repeat`
    app.style.backgroundSize = `100% 100%`
    if (to.path == '/startPoint') {
        document.querySelector('body').style.backgroundColor = '#111604'
    }else if (to.path == '/supply') {
        document.querySelector('body').style.backgroundColor = '#0C151F'
    }  else {
        document.querySelector('body').style.backgroundColor = `rgba(2,14,80)`
    }

    return next()
})
export default router